<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Blog</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>
    </div>
    <comingSoon />
  </div>
</template>

<script>
  import comingSoon from '@/pages/ComingSoon';
  
  export default {
    name: 'Blog',
    data () {
      return {
        
      }
    },
    components: {
      comingSoon
    },
    created () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Blog.vue